//
//
//
//
//
//
//
//
//
//
//
//

import LogList from "@/components/Query/LogList";
export default {
  name: "Log",
  data() {
    return {};
  },
  components: { LogList },
  mounted() {},
};
